/*eslint-disable*/
import React, { useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import {
    Table,
    TableContainer,
    TablePagination,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress,
    TableSortLabel
} from '@mui/material'
import dayjs from "dayjs";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import ActivityInfo from './activityInfo';
import useSort from "../../../../hooks/useSort";
import { selectUserActivitiesArray, selectUserActivitiesStatus } from "../../../../store/selectors/userActivities";
import styles from './activitiesTable.module.scss'
import { getTransactionDetail, sortUserActivities } from './activitiesTable.helpers';
import { useTranslation } from 'react-i18next';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 650,
      width: 580,
      height: 130,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

const ActivitiesTable = () => {
    const userActivities = useSelector(selectUserActivitiesArray) || [];
    const userActivitiesStatus = useSelector(selectUserActivitiesStatus);
    const areUserActivitiesLoading = userActivitiesStatus === 'loading';
    const { t } = useTranslation()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [activityInfo, setActivityInfo] = useState({})
    const [showActivityInfoDialog, setShowActivityInfoDialog] = useState(false)

    const { sortBy, sortOrder, handleSort } = useSort({ initialSortBy: 'timeStamp', initialSortOrder: 'asc', setPage })

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    useEffect(() => {
        setPage(0)
    },[userActivities])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    const sortedUserActivities = useMemo(() => sortUserActivities({ userActivities, sortBy, sortOrder }), [userActivities, sortBy, sortOrder])
    
    const renderTableHead = () => (
        <TableRow
            sx={{
                '& th': {
                    backgroundColor: '#F5F5F5',
                },
            }}
        >
            <TableCell className={styles.tableHeader}>
                <TableSortLabel
                    className={styles.userTableHeaderLabel}
                    active={sortBy === "timeStamp"}
                    direction={sortOrder}
                    onClick={() => handleSort("timeStamp")}
                >
                    {t('user-activities-table-date')}
                </TableSortLabel>
            </TableCell>
            <TableCell className={styles.userTableHeaderDetails}>
                {t('user-activities-table-method')}
            </TableCell>
            <TableCell className={styles.userTableHeader}>
                <TableSortLabel
                    className={styles.userTableHeaderLabel}
                    active={sortBy === "method"}
                    direction={sortOrder}
                    onClick={() => handleSort("method")}
                >
                {t('user-activities-table-transaction-details')}
                </TableSortLabel>
            </TableCell>
   {/* <TableCell className={styles.userTableHeader}>
                Okta Request Id
            </TableCell> */}
            
        </TableRow>
    )

    const closeActivityInfoDialog = () => {
        setShowActivityInfoDialog(false)
        setActivityInfo({})
    }

    const openActivityInfoDialog = (selectedActivityInfo) => {
        setActivityInfo(selectedActivityInfo)
        setShowActivityInfoDialog(true)
    }

    const getTooltipContent = activity => {
       // <HtmlTooltip title= {getTooltipContent(activity)} placement="right"></HtmlTooltip>
        return (
        <div className={styles.tooltipContainer}>
            <div className={styles.tooltipItem}>
                <div className={styles.tooltipLabel}>Method:  </div>
                <div className={styles.tooltipValue}>{activity.method}</div>
            </div>
            <div className={styles.tooltipItem}>
                <div className={styles.tooltipLabel}>Url:  </div>
                <div className={styles.tooltipValue}>{activity.url}</div>
            </div>
            <div className={styles.tooltipItem}>
                <div className={styles.tooltipLabel}>Id:  </div>
                <div className={styles.tooltipValue}>{activity.id}</div>
            </div>
            <div className={styles.tooltipItem}>
                <div className={styles.tooltipLabel}>Okta RequestId:  </div>
                <div className={styles.tooltipValue}>{activity.oktaRequestId}</div>
            </div>
        </div>
        )
    }
    

    const renderTableBody = () => {
        return sortedUserActivities
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((activity) => (
                <TableRow
                    className={styles.tableBodyRow}
                    key={activity.id}
                    onClick={() => openActivityInfoDialog(activity)}
                >
                    <TableCell sx={{ fontSize: '16px' }} className={styles.tableCell}>
                        {dayjs(activity.timeStamp).format('MM/DD/YYYY hh:mm:ssA')}
                    </TableCell>
                    <TableCell sx={{ fontSize: '16px' }} className={styles.tableCell}>
                        {activity.method}
                    </TableCell>
                    <TableCell sx={{ fontSize: '16px' }} className={styles.tableCell}>
                           {getTransactionDetail(activity)}
                    </TableCell>
                </TableRow>
            ))
    }
    return (
        <div className={styles.container}>
            <div className={styles.formContainer}>
                <TableContainer className={styles.tableContainer}>
                    <Table stickyHeader className={styles.userTable}>
                        <TableHead>{renderTableHead()}</TableHead>
                        <TableBody>
                            {areUserActivitiesLoading ? (
                                <TableRow>
                                    <TableCell sx={{ border: 'none' }} colSpan={6}>
                                        <div className={styles.loaderContainer}>
                                            <div className={styles.loading}>{t('loading')}</div>
                                            <CircularProgress
                                                sx={{
                                                    color: 'black',
                                                }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                renderTableBody()
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {userActivities.length > 10 && !areUserActivitiesLoading && (
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={userActivities.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                )}
            </div>
            <ActivityInfo 
                showDialog={showActivityInfoDialog} 
                closeDialog={closeActivityInfoDialog}
                activityInfo={activityInfo}
            />
        </div>
    )
}
export default ActivitiesTable